<template>
  <div style="position: relative;">
    <NBar :top="true" title="启动分布"/>
    <div class="tips-div"><span style="margin: 0 10px;">共{{ list.length }}个场地,{{ allStartupRate () }}个低于平均值</span></div>
    <div style="margin-top: 35px;">
      <nut-cell v-for="(item, index) in list" :key="index" style="position: relative;">
      <span slot="title" style="margin-left: 10px;display: flex;flex-direction: column;padding: 7px 0;">
        <span style="font-size: 16px;">{{ item.name }}</span>
        <span
          style="color: #666666;">共{{ item.deviceList.length }}台,启动{{ item.deviceList.filter (f => f.isOnline === 1).length }}台</span>
      </span>
        <span slot="desc" style="display: flex;align-items: center;margin-right: 10px;">
        <template v-if="startupRate(item) >= 50">
          <div style="margin-right: 10px;display: flex;flex-direction: column;">
            <span style="color:red;font-size:14px;">{{ startupRate (item) }}%</span>
            <span style="color: #666666;">启动率</span>
          </div>
          <img :src="require('../../../resource/img/device/svg/long-arrow-up.svg')" style="width: 20px;height: 20px;">
        </template>
        <template v-else>
          <div style="margin-right: 10px;display: flex;flex-direction: column;">
            <span style="color:#1afa29;font-size:14px;">{{ startupRate (item) }}%</span>
            <span style="color: #666666;">启动率</span>
          </div>
          <img :src="require('../../../resource/img/device/svg/long-arrow-down.svg')" style="width: 20px;height: 20px;">
        </template>
      </span>
      </nut-cell>
      <no-data :data="list"/>
    </div>
  </div>
</template>

<script>
/**
 * 启动分布
 */
export default {
  name: 'StartDistribution',
  data() {
    return {
      list: []
    }
  },
  activated() {
    this.getData ()
  },
  methods: {
    /**
     * 启动率
     * @param item
     * @return {string}
     */
    startupRate(item) {
      if (item.deviceList.length <= 0) {
        return 0.00
      }
      let upNum = item.deviceList.filter (f => f.isOnline === 1).length
      let allNum = item.deviceList.length
      return ((upNum / allNum) * 100).toFixed (2)
    },
    allStartupRate() {
      return this.list.filter (item => {
        if (item.deviceList.length <= 0) {
          return true
        }
        let upNum = item.deviceList.filter (f => f.isOnline === 1).length
        let allNum = item.deviceList.length
        return ((upNum / allNum) * 100).toFixed (2) < 50 ? true : false
      }).length
    },
    getData() {
      let data = {}
      if (!this.$util.isArrOrNull (this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      this.$api.post ({
        url: '/device/api/device/address/device-list',
        data: data
      }).then (res => {
        this.list = res.data
      })
    }
  }
}
</script>

<style scoped>
.tips-div {
  z-index: 10;
  background-color: #F5F6F8;
  position: fixed;
  top: 40px;
  height: 35px;
  display: flex;
  align-items: center;
  width: 100%;
}

.item-div {
  background-color: white;
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// src/components/device/home/StartDistribution.vue